import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from '@heroicons/react/solid';
import styled, { keyframes } from 'styled-components';
import { bounce } from 'react-animations';
import { PhoneIcon } from '@heroicons/react/outline';
import { useLocation } from 'react-router-dom';

const bounceAnimation = keyframes`${bounce}`;

const BouncyDiv = styled.div`
  animation: 1s ${bounceAnimation};
`;

export default function Contact({ totalDebt }) {
  const location = useLocation();
  const page = location.pathname;

  return (
    <div className='p-4'>

      <div id="new_lead" className='text-center text-gray-900'>
        <CheckCircleIcon className='mx-auto h-10 w-10 text-green-700' />
        <div className="text-center block text-xl font-semibold mb-2 text-gray-900">Great News!</div>
        <p className='text-center text-base p-5 text-gray-900'>You appear to be qualified for significant tax relief!</p>
      </div>

      <div className='max-w-lg mx-auto p-5 text-center text-gray-900'>
        <p className="text-base">
          To avoid waiting for a callback, call now to speak directly with a tax relief specialist. Our team can <b>review your situation immediately</b> and answer any questions about your options.
        </p>
        <div className='text-center'>
          <a
            href={page === "/call-now" ? "tel:800-730-6512" : "tel:8449844926"}
            className="hover:underline text-blue-600 flex items-center justify-center text-lg"
          >
            <PhoneIcon className='h-4 w-4 mr-2' />{page === "/call-now" ? "(800) 730-6512" : "(844) 984-4926"}
          </a>
        </div>
        <p className="mt-4 text-gray-600">
          Representatives are standing by.
        </p>
      </div>

      <div className='border-t max-w-lg mx-auto p-5 text-sm text-gray-700'>
        <p className='font-bold my-2'>Here are the next steps:</p>
        <div>
          <ol className='ml-5 list-decimal'>
            <li>You will be receiving a text and/or phone call from a tax resolution specialist.</li>
            <p className="italic">Please be sure to answer your phone and text messages when you see an unrecognized number so you don’t miss out on this opportunity.</p>
            <li>
              The tax resolution specialist will set up a time for you to have a <strong>FREE consultation with both the tax specialist and an IRS tax debt agent</strong> so you can discuss the best options for:

              <ol className="ml-4">
                <li>
                  a) Getting collections activity to stop</li>
                <li>
                  b) Getting as much of your tax debt forgiven as possible</li>
                <li>
                  c) Structure the best repayment plan for any debt that remains
                </li>

              </ol>
            </li>
            <li>
              If you like, for the best results with the least amount of time and frustration, you could even have a tax resolution specialist take care
              of your tax debt resolution for you with no out of pocket expense.
            </li>

          </ol>



        </div>
      </div>

    </div>
  );
}
